import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { CheckauthGuard } from './checkauth.guard';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { MoviedetailsComponent } from './moviedetails/moviedetails.component';
import { MoviesComponent } from './movies/movies.component';
import { RegisterComponent } from './register/register.component';
import { TvdetailsComponent } from './tvdetails/tvdetails.component';
import { TvshowComponent } from './tvshow/tvshow.component';

const routes: Routes = [
  {path :'' , redirectTo:`home`,pathMatch:`full` },
  {path :'home' , component: HomeComponent, canActivate: [CheckauthGuard] },
  {path :'about' , component: AboutComponent,canActivate: [CheckauthGuard]  },
  {path :'home/:pageNumber' , component: HomeComponent ,canActivate: [CheckauthGuard]  },
  {path :'tvshow/:pageNumber' , component: TvshowComponent ,canActivate: [CheckauthGuard]  },
  {path :'moviedetails/:id' , component: MoviedetailsComponent ,canActivate: [CheckauthGuard]  },
  {path :'tvdetails/:id' , component: TvdetailsComponent ,canActivate: [CheckauthGuard]  },

  {path :'movies' , component: MoviesComponent,canActivate: [CheckauthGuard]  },
  {path :'tvshow' , component: TvshowComponent,canActivate: [CheckauthGuard] },
  {path :'register' , component: RegisterComponent },
  {path :'login' , component: LoginComponent },
  {path :'**' , component: LoginComponent,canActivate: [CheckauthGuard] },










];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
